import { Typography, Stack, Switch } from '@mui/material';

export const GcpSourceAdvanceOptions = ({
  enableGcsBucketNotificationManagement,
  setEnableGcsBucketNotificationManagement,
}: {
  enableGcsBucketNotificationManagement?: boolean;
  setEnableGcsBucketNotificationManagement: (
    enableGcsBucketNotificationManagement: boolean
  ) => void;
}) => {
  return (
    <Stack direction='row' gap='12px' alignItems='center'>
      <Switch
        size='small'
        checked={enableGcsBucketNotificationManagement || false}
        onChange={(event) => {
          setEnableGcsBucketNotificationManagement(event.target.checked);
        }}
      />
      <Typography>{`Enable GCS bucket notification management`}</Typography>
    </Stack>
  );
};
